
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/genre/[slug]",
      function () {
        return require("private-next-pages/[lang]/genre/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/genre/[slug]"])
      });
    }
  